<div class="flex-container-center">
  <h2>{{ 'common.labels.jurisdictionTypeOrder' | transloco: { jurisdiction: (order.jurisdiction | jurisdictionLabel:order.country:order.displayJurisdiction), type: (order.orderTypeID | enumLabel:'orderType':order.orderType.name) } }}</h2>
</div>

<div class="flex-container-center padding-bottom-25">
  <h4>{{ 'common.labels.statusValue' | transloco: { status: order.orderStatusTypeID } }}</h4>
</div>

@if (uiConfiguration.amendmentConfiguration?.showChangeText) {
  <div class="section-container">
    <h4>{{ 'orders.changeText' | transloco }}</h4>
    <lib-change-text></lib-change-text>
  </div>
}

@if (uiConfiguration.hasReferenceRegistrationInformation && !isComplete()) {
  <div class="section-container">
    <h4>{{ 'common.labels.existingRegistrationDetails' | transloco }}</h4>
    <lib-existing-registration-details
      [uiConfiguration]="uiConfiguration.referenceRegistrationInformationUIConfiguration!">
    </lib-existing-registration-details>
  </div>
}

@if (uiConfiguration.hasLienDetails || (isDischarge() && uiConfiguration.hasDischargeDetails)) {
  <div class="section-container">
    <h4>{{ 'orders.orderTypeDetails' | transloco: { type: (order.orderTypeID | enumLabel:'orderType':order.orderType.name) } }}</h4>
    @if (!isDischarge() && isComplete()) {
      <lib-lien-results [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!"></lib-lien-results>
    }
    @if (isDischarge() && isComplete()) {
      <lib-discharge-details [uiConfiguration]="uiConfiguration.dischargeDetailsConfiguration!" [order]="order"></lib-discharge-details>
    }
    @if (uiConfiguration.hasLienDetails) {
      <lib-lien-details [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!"></lib-lien-details>
    }
  </div>
}

@if (uiConfiguration?.hasSecuredParties) {
  <div class="section-container">
    <h4>{{ 'common.labels.securedParties' | transloco }}</h4>
    <lib-parties-list [order]="order" [observableParties$]="securedParties" [isEditable]="false"
      [uiConfiguration]="uiConfiguration!.securedPartiesConfiguration!">
    </lib-parties-list>
  </div>
}

@if (uiConfiguration?.hasDebtors) {
  <div class="section-container">
    <h4>{{ 'orders.debtors' | transloco }}</h4>
    <lib-parties-list partyTypeTitle="Debtor" [order]="order" [observableParties$]="debtors" [isEditable]="false"
      [uiConfiguration]="uiConfiguration!.debtorsConfiguration!">
    </lib-parties-list>
  </div>
}

@if (uiConfiguration?.hasDealers) {
  <div class="section-container">
    <h4>{{ 'common.labels.dealers' | transloco }}</h4>
    <lib-parties-list partyTypeTitle="Dealer" [order]="order" [observableParties$]="dealers" [isEditable]="false"
      [uiConfiguration]="uiConfiguration!.dealersConfiguration!">
    </lib-parties-list>
  </div>
}

@if (uiConfiguration?.hasRegisteringAgents) {
  <div class="section-container">
    <h4>{{ 'common.labels.registeringAgents' | transloco }}</h4>
    <lib-parties-list partyTypeTitle="Registering Agent" [order]="order" [observableParties$]="registeringAgents"
      [isEditable]="false" [uiConfiguration]="uiConfiguration!.registeringAgentsConfiguration!">
    </lib-parties-list>
  </div>
}

@if (uiConfiguration?.collateralConfiguration?.hasGeneralCollateral) {
  <div class="section-container">
    <h4>{{ 'common.labels.generalCollateral' | transloco }}</h4>
    <lib-general-collateral [uiConfiguration]="$safeNavigationMigration(uiConfiguration.collateralConfiguration?.generalCollateralConfiguration)"
    [hideHistory]="true"></lib-general-collateral>
  </div>
}

@if (uiConfiguration?.collateralConfiguration?.hasAssets) {
  <div class="section-container">
    <h4>{{ 'common.labels.assets' | transloco }}</h4>
    <lib-asset-list [order]="order" [isEditable]="false"
      [uiConfiguration]="uiConfiguration!.collateralConfiguration!.assetConfiguration!">
    </lib-asset-list>
  </div>
}